/* eslint-disable camelcase */
import Api from '../api';

export const getPhrase = async () => {
  const response = await Api.get('/waranty_phrases');

  return response.data;
};

export const updatePhrase = async (phraseId: number, phraseStatus: number) => {
  const response = await Api.patch(`/waranty_phrases/${phraseId}`, { phrase_status: phraseStatus });
  return response.data;
};
